import { createStore } from 'vuex'
import createPersistedState from "vuex-persistedstate";

export default createStore({
  state: {
    userSession: null,
    loading: false,
    paginaFazerLogin: true,
    turmasEstudantes: null,
    anosLetivos: null,
    turmasProfessor: null,
    disciplinasProfessor: null,
    anosLetivosProfessor: null,
    turma: {
      idDaAula: null,
      idDaTurma: null,
      nomeDaTurma: null,
      anoDoEnsinoMedio: null,
    },
    aula: {
      idDaAula: null,
      disciplina: null,
      idDisciplina: null,
      tituloPlano: null,
      idPlano: null
    },
    
    

  },
  getters: {
  },
  mutations: {
    setUserSession(state, session) {
      state.userSession = session;
    },
    setLoading(state, value){
      state.loading = value
    },
    setTurma(state, { idDaAula, idDaTurma, nomeDaTurma, anoDoEnsinoMedio }) {
      state.turma.idDaAula = idDaAula;
      state.turma.idDaTurma = idDaTurma;
      state.turma.nomeDaTurma = nomeDaTurma;
      state.turma.anoDoEnsinoMedio = anoDoEnsinoMedio;
    },
    setAula(state, { idDaAula, disciplina, tituloPlano, idPlano, idDisciplina }) {
      state.aula.idDaAula = idDaAula;
      state.aula.disciplina = disciplina;
      state.aula.tituloPlano = tituloPlano;
      state.aula.idPlano = idPlano;
      state.aula.idDisciplina = idDisciplina;
    },
    setTurmasEstudantes(state, value){
      state.turmasEstudantes = value
    },
    setAnosLetivos(state, value){
      state.anosLetivos = value
    },
    setTurmasProfessor(state, value){
      state.turmasProfessor = value
    },
    setDisciplinasProfessor(state, value){
      state.disciplinasProfessor = value
    },
    setAnosLetivosProfessor(state, value){
      state.anosLetivosProfessor = value
    },
    setPaginaFazerLogin(state, value){
      state.paginaFazerLogin = value
    }
    
  },
  actions: {
    updateUserSession({ commit }, session) {
      commit('setUserSession', session);
    },
    updateLoading({commit}, value){
      commit('setLoading', value)
    },
    updateTurma({commit}, value){
      commit('setTurma',value)
    },
    updateAula({commit}, value){
      commit('setAula',value)
    },
    updateTurmasEstudantes({commit}, value){
      commit('setTurmasEstudantes',value)
    }, 
    updateAnosLetivos({commit}, value){
      commit('setAnosLetivos',value)
    },
    updateTurmasProfessor({commit}, value){
      commit('setTurmasProfessor',value)
    },
    updateDisciplinasProfessor({commit}, value){
      commit('setDisciplinasProfessor',value)
    },
    updateAnosLetivosProfessor({commit}, value){
      commit('setAnosLetivosProfessor',value)
    },
    updatePaginaFazerLogin({commit}, value){
      commit('setPaginaFazerLogin',value)
    }
},
  modules: {
    layout: {
      namespaced: true,
      state: {
        showHeaderFooter: true,
        showSidebar: true
      },
      mutations: {
        toggleFooter(state, value) {
          state.showHeaderFooter = value;
        },
        toggleSidebar(state, value){
          state.showSidebar = value;
        }
      },
    },

  },
  plugins: [createPersistedState({
    paths: ['userSession', 'turma', 'aula','paginaFazerLogin'],
    
  })],
})